export enum PurchaseOrderFileType {
  INVOICES = "Invoice",
  PDF = "PDF",
  CSV = "CSV",
  PACKING_LISTS = "Packing Lists",
  COMPLIANCE = "Compliance Documents",
  COMMERCIAL_INVOICE = "Commercial Invoice",
  COMMERCIAL_INVOICE_CSV = "Commercial Invoice CSV"
}

export enum WarehouseCheckInFileType {
  CHECK_IN_IMAGES = "Check-in Images",
  GOODS_IN_EXPORTS = "Goods-in Exports"
}
